import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              <br />
              <br />
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-APEX Reinsurance has achieved significant growth under your leadership. What key
                strategies have been most instrumental in driving this success?
              </strong>
            </h5>

            <h5 className="text-white">
              We have applied several strategies which have been driving our growth as follows:
              <br />
              <br />
              <b> Product mix:</b>
              <br />
              We focused on the non- congested areas for our growth; namely specialty lines of
              insurance and reinsurance, we focused on products where the underwriting skills in the
              market are relatively rare e.g. political violence, credit insurance, and financial
              lines which enables us to growth our business at much faster rates than our beers.
              <br />
              <br />
              <b>Customer services:</b>
              <br />
              In addition to the traditional placement of reinsurance we provided our clients with
              several value added services including but not limited to; market intelligence,
              product development, staff training, developing underwriting guidelines etc.
              <br />
              <br />
              <b> Digitalization:</b> <br />
              From the very beginning of our business, we have been using an efficient and friendly
              user information technology system which assisted us a lot in our financial analysis
              and in minimizing the manual work.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Financial analysis is a cornerstone of strategic decision-making. How do you
                ensure that financial insights support the achievement of business targets?
              </strong>
            </h5>
            <h5 className="text-white">
              The main focus here is the alignment of the financial insight with our business
              targets, and the main tools for achieving this is the tailored and SMART KPIs for each
              staff member and for the company as a whole, the financial reporting are designed to
              measures and to adjust our targets, if necessary. The financial analysis has been a
              major driver of our cost efficiency and our investment decisions.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-Tracking performance and making timely adjustments are essential to meeting
                business objectives. Can you share how you monitor performance and adapt strategies
                to stay on course?
              </strong>
            </h5>
            <h5 className="text-white">
              At the very beginning of the year we set SMART KPIs for each staff member. These KPIs
              are Specific, measurable, achievable, relevant and time bound. We prepare monthly
              performance report for each function, and compare it with the monthly target with
              corrective actions being taken, if required. Every quarter we have performance
              dialogue with each team member to highlight the strengths and weaknesses of the
              performance.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-The reinsurance market faces unique challenges today. What do you see as the
                biggest challenge in the current landscape, and how is APEX addressing it?
              </strong>
            </h5>
            <h5 className="text-white">
              The main challenges that are facing the reinsurance market are:
              <br />
              Hardening market conditions and capacity constraints,
              <br />
              We are striving to explore reinsurers with more flexible underwriting approach who are
              financially sound but they understand nature of our local and regional market.
              <br />
              Increased competition from the local and the international market players:
              <br />
              We distinguish ourselves by focusing on our areas of strength which is specialty lines
              of business and the value added services to our clients.
              <br />
              Inflation and increase cost of operations:
              <br />
              We are adopting cost efficient policy without sacrificing quality and we are always
              trying to ensure that our revenue growth rates are outpacing the increased cost of
              operation.
              <br />
              Increased regulatory and compliance requirements:
              <br />
              We have a dedicated compliance team to ensure that we are fully compliant with our
              legal and regulatory environment. We managed to comply with the new unified insurance
              law that was introduced in July 2024 in Egypt in terms of increased capital base,
              staff license etc before the end of the deadline.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Leadership often involves making critical decisions that shape business outcomes.
                Could you share an example of a strategic decision you made that had a major impact
                on APEX’s success?
              </strong>
            </h5>
            <h5 className="text-white">
              The main strategic decision that I have made and shaped our business outcome is to
              stay away from the crowded areas of our business i.e. the traditional reinsurance
              placement of property, engineering, marine etc and to focus on the specialty risks
              which need special and unique skills e.g. Political Violence, Credit, Event
              Cancellation, Directors and Officers liability, Bankers’ Blanket Bond etc.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Staying competitive requires anticipating future trends. How do you stay informed
                and ensure APEX remains at the forefront of industry advancements?
              </strong>
            </h5>
            <h5 className="text-white">
              I have been following several source of information e.g. Reinsurance News, AM Best
              News letters, Insurance Insider etc, in addition, I have been attending several
              webinars, Besides reading a number of publications of several market associations.
              Global market insight has been a major factor in our negotiations with our capacity
              providers to provide our clients with the best terms and conditions.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Risk management plays a pivotal role in reinsurance. How do you integrate risk
                management principles into your strategic decisions at APEX?
              </strong>
            </h5>
            <h5 className="text-white">
              Internally we adopt several risk management principals in order to protect our
              company, below are the main ones:
              <br />
              <br />
              <b>Cyber risk:</b>
              <br />
              We train our staff on avoid phishing and fraudulent transactions and we adopt a number
              of cyber resilience measures e.g. multi-factor authentication, regular back up of our
              data.
              <br />
              <br />
              <b>Regulatory and compliance risk:</b>
              <br />
              We have appointed a dedicated team for compliance, and AML functions.
              <br />
              <br />
              <b>Staff high turnover:</b>
              <br />
              We are following a strong staff retention policy.
              <br />
              <br />
              <b>Reputational risk:</b>
              <br />
              We have an internal review of all our transactions and communications to ensure that
              consistency, sound corporate governance and the application of our code of business
              ethics.
              <br />
              <br />
              Externally, we enlighten our client on the importance of making fair presentation to
              our business partners, the execution of risk improvement recommendations as indicated
              by the risk surveyors, and the importance of portfolio management and accumulation
              control.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Great leadership often defines organizational success. How would you describe your
                leadership philosophy, and how does it influence your team’s performance at APEX?
              </strong>
            </h5>
            <h5 className="text-white">
              I am following a number of best practices in staff retention strategies including:
              <br />
              <br />
              <b>Work-life balance:</b>
              <br />
              Our working hours are flexible including working from home for one day a week for the
              entire staff.
              <br />
              <br />
              <b>Job motivators:</b>
              <br />
              We recognize the achievement of our staff, we follow equal job opportunities policy
              with no discrimination based on gender, religion etc. The income of our staff is
              directly related to their individual job performance and the profitability of the
              company. We have tailored career bath plan for each job which ensure staff job
              satisfaction and career development. We care about our staff as we support them during
              any difficult times including financial difficulties. Our team members are heavily
              involved in setting our business targets and objectives.
              <br />
              <br />
              <b>Team work: </b>
              <br />
              Team work is one of the main success factors in our company, we always replace “I” by
              “we”
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
